const myCampaignsPage = {
  notFoundCampaigns: 'No se encontraron campañas',
  editingDisabled: 'La edición de la campaña heredada está deshabilitada. Por favor, edite la campaña en la plataforma heredada',
  startDisabled: 'El último lanzamiento de la campaña está deshabilitado. Por favor, inicie la campaña en la plataforma heredada',
  header: {
    toolbar: {
      all: 'Todos',
      active: 'Activo',
      pause: 'Pausa',
      draft: 'Reclutar',
      delayed: 'Retraso',
      failed: 'Fallido',
      completed: 'Terminado',
      canceled: 'Cancelado',
      archived: 'Archivado',
      moderation: 'Moderación',
      pending: 'Pendiente',
      rejected: 'Rechazado'
    }
  },
  table: {
    myCampaigns: 'Mis campañas',
    showing: 'Demostración',
    campaignsOf: 'campañas de',
    found: 'Encontrado',
    campaignFrom: 'campaña(s) de',
    nothingFoundBySearch: 'Nada encontrado por búsqueda',
    noCampaignsFound: 'No se encontraron campañas',
    noOrdersFound: 'No se encontraron pedidos',
    noAdvertisingFound: 'No se encontró publicidad',
    showAll: 'mostrar todo',
    showMore: 'mostrar más',
    showDetails: 'mostrar detalles',
    details: 'detalles',
    spreadInstallsFor24h: 'Propaga las instalaciones durante 24 horas',
    showReviews: 'Mostrar reseñas',
    promotionRuleStopsPromotionIfRankReachedRequiredLevel: 'La regla de promoción detiene la promoción si el rango alcanza el nivel requerido',
    installsDeliveryType: 'Tipo de entrega de instalaciones',
    vendor: 'Proveedor',
    changeVendor: 'Cambiar proveedor'
  },
  tableDropdown: {
    quickActions: 'Menú de acciones rápidas',
    exportCampaigns: 'Exportar Campañas',
    archiveAll: 'Archiva todo',
    refresh: 'Actualizar'
  },
  actionsDropdown: {
    start: 'Comienzo',
    startNow: 'Empieza ahora',
    pause: 'Pausa',
    cancel: 'Cancelar',
    archive: 'Archivo',
    edit: 'Editar',
    update: 'Actualizar',
    details: 'Detalles',
    resume: 'Reanudar',
    repeat: 'Repetir',
    clone: 'Clon',
    reject: 'Rechazar',
    moderation: 'Enviar para moderación',
    sendMessage: 'Enviar mensaje',
    forcedCompletion: 'Finalización forzada',
    forcedDraft: 'Proyecto forzado',
  },
  modalReview: {
    title: 'Mis reseñas de Campaña',
    exportReviews: 'Exportar reseñas'
  }
};
export default myCampaignsPage;
